import { all, put, select, takeLatest, call } from 'redux-saga/effects';

import { isOfficeRentSearch } from '../../../utils/isOfficeRentSearch';
import { isAbUseExperimentGroup } from '../../../utils/experiments/isAbUseExperimentGroup';
import { IAppState } from '../../../common/state';
import { AB_COWORKING_POPUP_EXPERIMENT } from '../../../constants/coworkingsExperiment';

const LOCAL_STORAGE_COWORKING_AD_MODAL_ITEM = 'isCoworkingAdModalClosed';

// ACTION TYPES
export const COWORKING_AD_MODAL_OPENED = 'modals/coworking_modal_ad/MODAL_OPENED';
export const COWORKING_AD_MODAL_CLOSED = 'modals/coworking_modal_ad/MODAL_CLOSED';
const USER_CLICK_TO_OFFER = 'userClickToOffer';

// ACTIONS
export interface ICoworkingAdModalOpened {
  type: typeof COWORKING_AD_MODAL_OPENED;
}
export interface ICoworkingAdModalClosed {
  type: typeof COWORKING_AD_MODAL_CLOSED;
}
export interface IUserClickToOffer {
  type: typeof USER_CLICK_TO_OFFER;
}

export type TCoworkingAdModalActions = ICoworkingAdModalOpened | ICoworkingAdModalClosed;

export const openCoworkingAdModal = (): ICoworkingAdModalOpened => ({ type: COWORKING_AD_MODAL_OPENED });
export const closedCoworkingAdModal = (): ICoworkingAdModalClosed => ({
  type: COWORKING_AD_MODAL_CLOSED,
});

export const onOfferClick = (): IUserClickToOffer => ({ type: USER_CLICK_TO_OFFER });

// SAGAS
export function* handleUserClickToOffer() {
  const {
    logger,
    isCoworkingExperimentsEnabled,
    filters: { jsonQuery },
    abUseExperiments,
  } = (yield select()) as IAppState;

  const isExperimentEnabled: boolean = yield call(
    isAbUseExperimentGroup,
    abUseExperiments,
    AB_COWORKING_POPUP_EXPERIMENT,
    'B',
  );

  if (!isCoworkingExperimentsEnabled || !isExperimentEnabled) {
    return;
  }

  try {
    const isCoworkingAdModalClosed = localStorage.getItem(LOCAL_STORAGE_COWORKING_AD_MODAL_ITEM);

    if (isOfficeRentSearch(jsonQuery) && isCoworkingAdModalClosed !== 'true') {
      yield put(openCoworkingAdModal());

      localStorage.setItem(LOCAL_STORAGE_COWORKING_AD_MODAL_ITEM, 'true');
    }
  } catch (e) {
    logger.warning(e, {
      description: 'Попытка обращения к localStorage',
      domain: 'handleUserClickToOffer',
      message: 'Ошибка при чтении или записи данных в localStorage',
    });
  }
}

export function* coworkingAdModalSagas() {
  yield all([takeLatest(USER_CLICK_TO_OFFER, handleUserClickToOffer)]);
}

// REDUCER
export interface ICoworkingAdModal {
  isOpen: boolean;
}

export const initialState = {
  isOpen: false,
};

export const coworkingAdModalReducer = (
  state: ICoworkingAdModal = initialState,
  action: TCoworkingAdModalActions,
): ICoworkingAdModal => {
  switch (action.type) {
    case COWORKING_AD_MODAL_OPENED:
      return {
        isOpen: true,
      };

    case COWORKING_AD_MODAL_CLOSED:
      return {
        isOpen: false,
      };

    default:
      return state;
  }
};
